import { render } from "./PermissionRouterLink.vue?vue&type=template&id=89a590b0&scoped=true"
import script from "./PermissionRouterLink.vue?vue&type=script&lang=js"
export * from "./PermissionRouterLink.vue?vue&type=script&lang=js"

import "./PermissionRouterLink.vue?vue&type=style&index=0&id=89a590b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a590b0"]])

export default __exports__